import { useMutation } from '@tanstack/react-query';

import { request } from '~/services/common';

import { StopsellExtraction } from '~/types/stopsell';

export type ExtractCatalogRoom = {
  id: string;
  name: string;
};

interface ExtractStopsellsInput {
  file: File;
  catalogRooms?: Array<ExtractCatalogRoom>;
}

export function useExtractStopsellDates() {
  return useMutation({
    mutationFn: async ({ file, catalogRooms = [] }: ExtractStopsellsInput): Promise<StopsellExtraction> => {
      const formData = new FormData();
      formData.append('file', file);
      if (catalogRooms.length > 0) {
        formData.append(
          'roomTypes',
          JSON.stringify(
            catalogRooms.map(({ id, name }) => ({
              id,
              name,
            })),
          ),
        );
      }

      return request(`${window.configs.API_HOST}/api/ai-hotel/stopsell/extract`, {
        method: 'POST',
        body: formData,
      });
    },
  });
}
